import React, { Component } from "react";
import Dropdown from "react-dropdown";

export class linkAccountStepTwo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "Choose Account Type",
      accountType: "",
    };
  }

  // handleChangeSelect = (event) => {
  //   console.log('event.target.value', event.target.value)
  //   this.setState({
  //     value: event.target.value
  //   });
  // };
  handleOnclickSelect = (e) => {
    this.setState({
      accountType: e.value,
    });
    this.props.onChangeStep2Select(e.value);
  };

  render() {
    return (
      <div className="link-acc">
        {/* <h2 className="text-center tab-h">
          {this.props.addMultipleAccountState == true
            ? "Add Account"
            : "Link Account"}
        </h2> */}
        <h3 className="text-center tab-h3">Add the information to link your bank account.</h3>
        <div className="row  top-tab w-link-tab">
          <form onSubmit={this.props.handlePopupSubmit}></form>
          <div class="input-field col m12  t-left dropdown-form">
            <label className="active top-l">Account Type</label>

            <Dropdown
              name="accountType"
              className="browser-default"
              options={[
                { value: "1", label: "Checking", name: "Checking" },
                { value: "2", label: "Savings", name: "saving" },
              ]}
              onChange={this.handleOnclickSelect}
              value={this.props.accountType}
              placeholder="Account Type"
            />
            <div className="error-class" style={{ fontSize: 12, color: "red" }}>
              {this.props.accountTypeError}
            </div>
          </div>
          <div class="input-field col m12 t-left">
            <input
              placeholder="Routing Number"
              class="form-control tab-input"
              type="number"
              name="routingNumber"
              value={this.props.routingNumber}
              onChange={this.props.onChangeStep2}
            />
            <label class="active top-l" for="Routing Number">
              Routing Number
            </label>
            <div className="error-class" style={{ fontSize: 12, color: "red" }}>
              {this.props.routingNumberError}
            </div>
          </div>
          <div class="input-field col m12 t-left">
            <input
              placeholder="Account Number"
              class="form-control"
              type="number"
              name="accountNumber"
              value={this.props.accountNumber}
              onChange={this.props.onChangeStep2}
            />
            <label class="active top-l" for="Account Number">
              Account Number
            </label>
            <div className="error-class" style={{ fontSize: 12, color: "red" }}>
              {this.props.accountNumberError}
            </div>
          </div>
          <div class="input-field col m12 t-left">
            <input
              placeholder="Account Holder Name"
              class="form-control"
              type="text"
              name="accountHolderName"
              value={this.props.accountHolderName}
              onChange={this.props.onChangeStep2}
            />
            <label class="active top-l" for="Account Holder Name">
              Account Holder Name
            </label>
            <div className="error-class" style={{ fontSize: 12, color: "red" }}>
              {this.props.accountHolderNameError}
            </div>
          </div>
          <div class="input-field col m12 t-left">
            <input
              placeholder="Display Name"
              class="form-control"
              type="text"
              name="displayName"
              value={this.props.displayName}
              onChange={this.props.onChangeStep2}
            />
            <label class="active top-l" for="Bank Name">
            Give this account a nickname <span class="qus-icon">?</span>
            </label>
            <div className="error-class" style={{ fontSize: 12, color: "red" }}>
              {this.props.displayNameError}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default linkAccountStepTwo;
